// Browser adapter for the app's lightweight preferences. Storage failures never block controls.
export const usergetStorageSync = key => {
  try {
    const value = localStorage.getItem(key)
    return value == null ? undefined : JSON.parse(value)
  } catch (_) {
    return undefined
  }
}
export const usersetStorageSync = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (_) {}
  return value
}
export const usersetStorage = usersetStorageSync
